import { Calendar, User, ArrowRight, Clock } from "lucide-react"
import { Link } from "react-router-dom"
import { getCategoryLabel } from "../../utils/categoryLabels"

function estimateReadTime(html) {
  if (!html) return ''
  const text = typeof html === 'string' ? html.replace(/<[^>]+>/g, '') : ''
  const words = text.split(/\s+/).filter(Boolean).length
  return words ? `${Math.max(1, Math.ceil(words / 200))} min` : ''
}

export default function BlogPostCard({ post, space }) {
    const blogPath = space ? `/etudiants/blog/${space}` : "/etudiants/blog"
    const postId = post._id || post.id
    const headlineMedia = post.headlineImage
    const imageUrl = headlineMedia?.url ?? post.headlineImage
    const isVideo = headlineMedia?.resourceType === 'video'
    const image = imageUrl ? (
        isVideo ? (
            <video src={imageUrl} className="w-full h-full object-cover" muted playsInline />
        ) : (
            <img src={imageUrl} alt={post.title} className="w-full h-full object-cover" />
        )
    ) : post.image
    const author = post.authorName ?? (post.author && (typeof post.author === 'object' ? post.author.fullname : post.author)) ?? ''
    const dateSource = post.publishedAt || post.createdAt
    const displayDate = dateSource
        ? new Date(dateSource).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })
        : post.date

    return (
        <article className="bg-card rounded-2xl border border-border overflow-hidden hover:shadow-lg transition-all group">
            <div className="h-48 bg-gradient-to-br from-primary/10 to-accent/5 flex items-center justify-center text-6xl">
                {image}
            </div>
            <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                    <span className="px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-semibold">
                        {getCategoryLabel(post.category)}
                    </span>
                    <div className="flex items-center gap-1 text-xs text-muted-foreground">
                        <Clock className="w-3 h-3" />
                        <span>{post.readTime || estimateReadTime(post.body)}</span>
                    </div>
                </div>
                <h2 className="text-xl font-bold mb-3 text-foreground group-hover:text-primary transition-colors">
                    {post.title}
                </h2>
                <p className="text-muted-foreground mb-4 line-clamp-3">
                    {post.excerpt || (post.body ? post.body.replace(/<[^>]+>/g, '').slice(0, 150) + '...' : '')}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-border">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                        <User className="w-4 h-4" />
                        <span>{author}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                        <Calendar className="w-4 h-4" />
                        <span>{displayDate}</span>
                    </div>
                </div>
                <Link
                    to={`/article/${postId}`}
                    className="mt-4 w-full flex items-center justify-center gap-2 text-primary font-semibold hover:gap-3 transition-all group/btn"
                >
                    Voir l'article
                    <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                </Link>
            </div>
        </article>
    )
}
